import { Element } from "react-scroll";
import SectionTitle2 from "../sectionTitle/SectionTitle2";
import { Link } from "react-router-dom";

export default function WILWorkforceDevelopment() {

  const upskilling = [
    {
      id: 1,
      image: "datatalent.jpg",
      title: "DataTalent",
      description: "16-week hands-on Upskilling program in Data, ML, and AI with Employer-led projects.",
      link: "/programs/datatalent/jobseekers"
    },
    {
      id: 2,
      image: "datatalent.avif",
      title: "AIWorks",
      description: "Applied AI training series across Industries in partnership with leading Universities & Enterprises.",
      link: "https://courses.m2mtechconnect.com/bundles/applied-ai-for-industries"
    },
    {
      id: 3,
      image: "ai_ready_v2.jpg",
      title: "AI Ready",
      description: "Work-Integrated Learning and talent evaluation program connecting Employers with AI-skilled professionals.",
      link: "/programs/membership/aiready"
    },
  ]

  return (
    <>
      <Element
        name="HomeWorkforceDevelopment"
        className="datatalent-section-gap workforce-development"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5 justify-content-center">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Recommended Programs"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center section-description">Empowering Canada's Future Workforce with Industry-Aligned AI Training and Career Ready Programs.</p>
            </div>
            {upskilling.map((upskill) => <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={upskill.id}>
              <div className="home-iau-card">
                <div className="home-iau-image">
                  <img src={`${process.env.PUBLIC_URL}/images/home/${upskill.image}`} alt={upskill.title} />
                </div>
                <div className="home-iau-content">
                  <h5 className="mb-2">{upskill.title}</h5>
                  <p className="mb-4">{upskill.description}</p>
                  <Link to={upskill.link} className="d-flex flex-row align-items-center justify-content-start gap-2 home-links">Learn more<i className="icon-arrow-right-line-right"></i></Link>
                </div>
              </div>
            </div>)}
          </div>
        </div>
      </Element>
    </>
  )
}